import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 11\" id=\"check\">\n    <path d=\"M5.847 7.779l5.112-6.745a.9.9 0 1 1 1.434 1.087L6.69 9.647a.9.9 0 0 1-1.32.125L1.379 6.176a.9.9 0 0 1 1.205-1.337l3.263 2.94z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol